"use strict";
/* eslint-disable sort-keys-fix/sort-keys-fix */
/* ============ API REST Endpoints ============= */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PATH = void 0;
const portalEndpoints = {
    // User Account
    USER_ACCOUNT: "/user/account",
    USER_ACCOUNT_SETTINGS: "/user/account/settings",
    USER_NOTIFICATIONS: "/user/notifications",
    USER_NOTIFICATION_EXPIRE: "/user/notifications/expire",
    ACTIVE_SUBSCRIPTION_INFO: "/user/subscriptions/active",
    RESEND_EMAIL_CONFIRMATION: "/user/resendemailconfirmation",
    COUPON_CODE_VALIDATE: "/couponcode/validate",
    COUPON_CODE_REDEEM: "/couponcode/redeem",
    GET_CHURN_COUPON: "/churn_coupon",
    // Subscriptions
    SUBSCRIPTION_START: "/subscriptions/start",
    SUBSCRIPTION_ON_CREATED: "/subscriptions/oncreated",
    SUBSCRIPTION_PORTAL_CREATE: "/subscriptions/portal/createsession",
    SUBSCRIPTION_CREATE_BACKER_PLAN: "/subscriptions/backer/create",
    SUBSCRIPTION_CANCEL: "/subscriptions/cancel",
    SUBSCRIPTION_REFUND: "/subscriptions/refund",
    SUBSCRIPTION_COUPON_INFO: "/subscriptions/coupon",
    SUBSCRIPTION_CREATE_TEST: "/subscriptions/test",
    SUBSCRIPTION_APPLY_COUPON: "/subscriptions/coupon/apply",
    // Cancellation survey
    ANSWER_CANCELLATION_SURVEY: "/cancellation_survey",
    // Analytics endpoints that will help us with tracking User's actions on Portal via Service
    REGISTER_ANONYMOUS_EVENT: "/register_anonymous_event",
    REGISTER_EVENT: "/register_event",
    LINK_USER: "/link_user", // Can be used to link an anonymous user with a userId after they log into Portal
};
const appEndpoints = {
    // APP API
    API_PREFIX: "/v1",
    APP_LOGIN: "/app_login",
    LANGUAGE_MODULE: "/language_module/:code",
    LANGUAGE_MODULES: "/language_modules",
    IN_APP_PURCHASE: "/in_app_purchase",
    PERMISSIONS: "/permissions",
    USER_PREFERENCES: "/preferences",
    THE_METHOD_WATCHED_VIDEOS: "/the_method_watched_videos",
    RATINGS: "/ratings",
    ACTIVATE_BACKER_SUBSCRIPTION: "/backer/activate",
    GUIDED_LEARNING_QUOTE: "/guided_learning_quote/week/:weekId/chapter/:chapterId",
    INTERVIEW_EMAIL: "/interview_email",
    // Dev/Debug API
    EXPIRE_TRIAL: "/expire_trial",
    EXTEND_TRIAL: "/extend_trial",
    // LANGUAGE
    LANGUAGE_PREFIX: "/v1/:langPairCode",
    WORD_STATUS: "/word/:id/status",
    WORD_LIST: "/word_list",
    SENTENCE: "/sentences/:id",
    SENTENCES_BY_WORD: "/sentences/word/:id",
    SENTENCES_BY_TOPIC: "/sentences/topic/:id",
    SENTENCE_SEARCH: "/sentence_word/search",
    IMAGE_SEARCH: "/image_search",
    IMAGE_ASSOCIATE_WORD_ENTRY: "/image_associations/word_entry/:id",
    IMAGE_ASSOCIATE_PREMADE_FLASHCARD_WORD: "/image_associations/premade_flashcard_word/:id",
    IMAGE_ASSOCIATE_WORD: "/image_associations/word/:id",
    IMAGE_ASSOCIATE_SENTENCE: "/image_associations/sentence_word/:id",
    IMAGE_ASSOCIATE_EXTENDED_WORD: "/image_associations/extended_word/:id",
    IMAGE_ASSOCIATE_CUSTOM_TRANSLATION: "/image_associations/custom_translation/:id",
    IMAGE_RECOMMENDATIONS_PREMADE_FLASHCARD_WORD: "/image_associations/premade_flashcard_word/:id/search",
    IMAGE_RECOMMENDATIONS_WORD: "/image_associations/word/:id/search",
    IMAGE_RECOMMENDATIONS_SENTENCE_WORD: "/image_associations/sentence_word/:id/search",
    IMAGE_RECOMMENDATIONS_EXTENDED_WORD: "/image_associations/extended_word/:id/search",
    IMAGE_RECOMMENDATIONS_CUSTOM_TRANSLATION: "/image_associations/extended_word/:id/search",
    FLASHCARDS_CREATE_FROM_SET: "/flashcards/flashcard_set/:id",
    FLASHCARDS_CREATE_FROM_WORD_ENTRY: "/flashcards/word_entry/:id",
    FLASHCARDS_CREATE_FROM_WORD: "/flashcards/word/:id",
    FLASHCARDS_CREATE_FROM_SENTENCE_WORD: "/flashcards/sentence_word/:id",
    FLASHCARDS_CREATE_FROM_EXTENDED_WORD: "/flashcards/extended_word/:id",
    FLASHCARDS_CREATE_FROM_CUSTOM_TRANSLATION: "/flashcards/extended_word/custom",
    FLASHCARDS_SCHEDULING_GET: "/flashcards/scheduling",
    FLASHCARDS_CREATE_REVIEW_SESSION: "/flashcards/review_session",
    FLASHCARDS_SUBMIT_ANSWER: "/flashcards/:id/answer",
    FLASHCARDS_UNDO_ANSWER: "/flashcards/:id/undo",
    FLASHCARDS_FREEZE: "/flashcards/freeze",
    FLASHCARDS_UNFREEZE: "/flashcards/unfreeze",
    GET_HAS_FROZEN_FLASHCARDS: "/flashcards/has_frozen",
    PRONUNCIATION_FLASHCARDS_PROGRESS: "/pronunciation_flashcards_progress",
    PRONUNCIATION_LESSONS: "/pronunciation_lessons",
    VIDEO_VIEW: "/videos/:id/view",
    DAILY_GOALS: "/daily_goals",
    USER_LANGUAGE_PREFERENCES: "/preferences",
    USER_PROGRESS: "/user/progress",
    USER_RESET_DATA: "/user/resetdata",
    BASE_VOCAB_SETS: "/base_vocab_sets",
    ERROR_REPORT: "/error_reports",
    IMAGE_EXISTS: "/image_exists",
    IMAGES: "/images",
    ONBOARDING_WORD: "/onboarding_word",
    FETCH_LANGUAGE_PROGRESS: "/languageProgress",
    // Remove "MY_FLASHCARD_WORDS" endpoint after releasing 4332
    MY_FLASHCARD_WORDS: "/my_flashcard_words",
    MY_FLASHCARD_ENTRIES: "/my_flashcard_entries",
    // Guided learning
    GET_GUIDED_LEARNING_TASKS: "/guided_learning_tasks",
    COMPLETE_GUIDED_LEARNING_TASK: "/guided_learning_tasks/:id",
    // Word entries
    LOOKUP_WORD_ENTRIES: "/word_entries/lookup",
    // Delete flashcard
    DELETE_FLASHCARD: "/flashcards/:id",
    DELETE_FLASHCARD_BACK: "/flashcard_backs/:id",
    // Bootcamp sentences
    FLASHCARDS_CREATE_FROM_UGC_SENTENCE: "/flashcards/ugc_sentence/:id",
    IMAGE_ASSOCIATE_UGC_SENTENCE_FLASHCARD: "/image_associations/ugc_sentence_flashcard/:id",
    UGC_SENTENCES_FOR_USER: "/ugc/sentences",
    SANITY_WEBHOOK: "/webhooks/sanity",
    // Surveys:
    GET_AVAILABLE_SURVEYS: "/surveys/available",
    ANSWER_SURVEY: "/surveys/answer/:id",
    // Subscription:
    SUBSCRIPTION: {
        PREFIX: "/subscription",
        DETAILS: "/details",
    },
    // Progress Report
    PROGRESS_REPORT: {
        PREFIX: "/progress_reports",
        ALL: "/all",
    },
    // MXU Bootcamp
    MXU: {
        PREFIX: "/mxu",
        BOOTCAMP_CANCEL: "/bootcamp_cancel",
        BOOTCAMP_DATES: "/bootcamp_dates",
        BOOTCAMP_DATES_AVAILABLE: "/bootcamp_dates_available",
        BOOTCAMP_ENROLLMENT: "/bootcamp_enrollment",
        BOOTCAMP_EVALUATE_UNPAID: "/bootcamp_evaluate_unpaid",
        BOOTCAMP_LANGUAGES: "/bootcamp_languages",
        BOOTCAMP_PARTICIPANT: "/bootcamp/participants/:userId",
        BOOTCAMP_PARTICIPANTS: "/bootcamp/participants",
    },
    WEEKLY_COACHING: {
        PREFIX: "/weekly_coaching",
        CHECKOUT: "/checkout",
        PLANS: "/plans",
        PLANS_ALL: "/plans/all",
        CONFIRM_CHECKOUT: "/confirmation",
        SUBSCRIPTIONS: "/subscriptions",
        USER_SUBSCRIPTIONS: "/user_subscriptions",
        CANCEL: "/cancel",
        REACTIVATE: "/reactivate",
    },
    // GET "/v1/en-US_de-DE/audio/tts?word=Hund"
    AUDIO: {
        PREFIX: "/audio",
        TTS: "/tts",
    },
    TOPICS: "/topics",
    USER: {
        DELETE: "/user/delete_account",
    },
};
/** REST ENDPOINT PATHs */
exports.PATH = {
    ...portalEndpoints,
    ...appEndpoints,
};
//# sourceMappingURL=path.js.map